"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitTextField = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var styles_1 = require("@material-ui/core/styles");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        count: {
            marginLeft: theme.spacing(1),
        },
        label: {
            fontWeight: 400,
            paddingBottom: theme.spacing(1),
        },
    });
});
var LimitTextField = function (props) {
    var _a = react_1.default.useState(props.value ? props.value : ""), text = _a[0], setText = _a[1];
    var classes = useStyles(props);
    react_1.default.useEffect(function () {
        setText(props.value ? props.value : "");
    }, [props.value]);
    var handleTextFieldChange = function (e) {
        e.target.value = e.target.value.slice(0, props.limit);
        setText(e.target.value);
        if (props.onChange) {
            props.onChange(e);
        }
    };
    var propsToPass = __assign({}, props);
    var labelId = "";
    if (propsToPass.label) {
        labelId = lodash_1.kebabCase(propsToPass.label);
        delete propsToPass.label;
    }
    var id = props.id ? props.id : (props.label ? labelId : undefined);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!props.label &&
            react_1.default.createElement(InputLabel_1.default, { error: !!props.errorText || props.error, htmlFor: id }, props.label),
        react_1.default.createElement(TextField_1.default, __assign({}, propsToPass, { id: id, onChange: handleTextFieldChange, value: text, error: !!props.errorText || props.error })),
        props.showCount && (react_1.default.createElement(Typography_1.default, { variant: "subtitle2", className: classes.count, style: (text.length === props.limit) ? { color: "Red" } : undefined }, text.length + " / " + props.limit)),
        !!props.errorText &&
            react_1.default.createElement(FormHelperText_1.default, { error: !!props.errorText }, props.errorText)));
};
exports.LimitTextField = LimitTextField;
exports.LimitTextField.defaultProps = {
    showCount: true,
};
